// rfqListConfig.ts
export interface RFQColumn {
  key: string;
  label: string;
  align?: "left" | "center" | "right";
  width?: string;
}

export interface RFQStatusStyle {
  background: string;
  textColor: string;
}

export interface ListConfig {
  columns: RFQColumn[];
  styles: {
    headerBg: string;
    headerText: string;
    rowHover?: string;
    statusStyles?: Record<string, RFQStatusStyle>;
  };
}

export const rfqListConfig: ListConfig = {
  columns: [
    { key: "id", label: "RFQ ID", align: "left", width: "w-[120px]" },
    { key: "title", label: "Title", align: "left" },
    { key: "category", label: "Category", align: "left" },
    { key: "buyerCompany", label: "Company", align: "left" },
    { key: "country", label: "Country", align: "left" },
    { key: "quantity", label: "Qty", align: "right" },
    { key: "createdAt", label: "Created", align: "left" },
    { key: "dueDate", label: "Due", align: "left" },
    { key: "status", label: "Status", align: "center" },
    { key: "actions", label: "Actions", align: "center" },
  ],
  styles: {
    headerBg: "bg-gray-100",
    headerText: "text-gray-700",
    rowHover: "hover:bg-muted/40",
    statusStyles: {
      Open: { background: "bg-green-100", textColor: "text-green-800" },
      Closed: { background: "bg-red-100", textColor: "text-red-800" },
      Pending: { background: "bg-yellow-100", textColor: "text-yellow-800" },
    },
  },
};
